import ViewFluxoKamban from './ViewFluxoKamban'
import enhance from './ViewFluxoKamban.enhancer'

export default enhance(ViewFluxoKamban)



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/FluxoKamban/components/ViewFluxoKamban/index.js